'use client'

import MiniPDPCollection from '../../organisms/productPageSections/miniPDPCollection'
import { MiniPDPProductImages } from '../../organisms/productPageSections/miniPDPProductImages/miniPDPProductImages'
import { MiniPDPProductPurchase } from '../../organisms/productPageSections/miniPDPProductPurchase/miniPDPProductPurchase'

import styles from './miniPDP.module.scss'

import type { ProductPageContext } from '../../domains/MiniPDPContext'

export const MiniPDPLegacy = ({ pageData }: { pageData: ProductPageContext }) => {
  return (
    <>
      <div className={styles.miniPDP__container}>
        <MiniPDPProductImages sectionData={pageData.sectionData} product={pageData.product} />
        <MiniPDPProductPurchase product={pageData.product} sectionData={pageData.sectionData} />
      </div>
      <div className={styles.border} />
      <MiniPDPCollection
        collectionId={pageData.product.productRecommendations.mpdp.data.id}
        product={pageData.product}
        sectionData={pageData.sectionData}
      />
    </>
  )
}
